<script>
/* eslint-disable */
import Draggable from "vuedraggable";
import Move from "./Move.vue";
import DynamicItemRound from "./DynamicItemRound.vue";
import bracketBody from "../../../static/assets/images/bracket-body.png";
import bracketTop from "../../../static/assets/images/bracket-top.png";
import bracketCenter from "../../../static/assets/images/bracket-center.png";
import bracketDown from "../../../static/assets/images/bracket-down.png";

const setDragCursor = (value) => {
  const html = document.getElementsByTagName("html").item(0);
  html.classList.toggle("grabbing", value);
};

export default {
  props: ["item", "circuit", "parentItem"],
  name: "Round",
  components: {
    Move,
    DynamicItemRound,
    Draggable,
  },
  data() {
    return {
      bracketBody,
      bracketTop,
      bracketCenter,
      bracketDown,
      items: this.item.items,
      settings: {
        direction: "right",
        thickness: 1,
        sharpness: 1,
        point: 0.5,
      },
      repeat: this.item.reps ? this.item.reps : 0,
    };
  },
  watch: {
    item(newItem) {
      this.items = newItem.items;
    },
    items(newItems) {
      this.$store.commit("scripts/setRoundItems", {
        roundId: this.item.id,
        items: newItems,
      });
    },
    repeat(newVal) {
      let val = parseInt(newVal);
      this.$store.dispatch("scripts/updateItemNoSync", {
        reps: val,
        id: this.item.id,
      });
    },
  },
  methods: {
    handleBlur(e) {
      let val = parseInt(this.repeat);
      this.$store.dispatch("scripts/updateItem", {
        reps: val,
        id: this.item.id,
      });
    },
    onDragStart() {
      setDragCursor(true);
    },
    onDragEnd() {
      setDragCursor(false);
    },
    unround() {
      this.$store.dispatch("scripts/ungroupRound", this.item.id);
    },
  },
};
</script>


<style scoped>
.round-list {
  margin: 0;
  padding: 0;
  position: relative;
}
.pointer {
  position: absolute;
  top: 200px;
  left: 450px;
}
.note {
  position: absolute;
  top: 120px;
  left: 350px;
  text-align: center;
}
.works-reps {
  position: absolute;
  top: 16px;
  right: 0;
  width: 250px;
}

.checkbox .round {
  margin-left: 1rem;
}

.separator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.separator span {
  font-weight: 600;
  font-size: 20px;
}
.canvas-curly-braces {
  width: 50px;
  height: 121px;
  position: absolute;
  right: 200px;
  top: 0;
}
.box-delete {
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  width: 200px;
  height: 121px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding-top: 10px; */
}
.box-container {
  display: inline-flex;
  margin-top: -15px;
  align-items: center;
}
.x {
  font-size: 28px;
  font-weight: bold;
  font-family: "Times New Roman", Times, serif;
  margin-right: 30px;
}
.input-box {
  width: 46px;
  padding: 5px !important;
  height: 38px;
  text-align: center;
  margin-right: 35px;
}

.round-list .bracket {
  background-image: var(--bracketBody);
  position: absolute;
  top: 0;
  display: block;
  height: 94%;
  width: 1.5rem;
  background-size: contain;
  right: 200px;
}
.round-list .bracket .center {
  background-image: var(--bracketCenter);
  content: "";
  width: 1.5rem;
  background-size: contain;
  position: absolute;
  top: calc(50% - 15px);
  height: 50px;
  background-repeat: no-repeat;
}
.round-list .bracket::before {
  background-image: var(--bracketTop);
  background-color: #ffffff;
  content: "";
  width: 100%;
  height: 1rem;
  position: absolute;
  background-size: contain;
  top: -1px;
  left: 0px;
  background-repeat: no-repeat;
}
.round-list .bracket::after {
  background-color: #ffffff;
  background-image: var(--bracketDown);
  content: "";
  width: 100%;
  height: 1rem;
  position: absolute;
  background-size: contain;
  bottom: -1px;
  left: 0px;
  background-repeat: no-repeat;
}
</style>

<template>
  <div
    class="round-list"
    ref="round-list"
    :style="{ 
      '--bracketBody': 'url(' + bracketBody + ')',
      '--bracketTop': 'url(' + bracketTop + ')',
      '--bracketCenter': 'url(' + bracketCenter + ')',
      '--bracketDown': 'url(' + bracketDown + ')',
      }"
  >
    <draggable
      v-model="items"
      @start="onDragStart"
      @end="onDragEnd"
      class="drag-list"
    >
      <dynamic-item-round
        v-for="item in items"
        :key="item.id"
        :item="item"
        :circuit="circuit"
        :parentItem="parentItem"
      ></dynamic-item-round>
    </draggable>
    <span class="bracket"><span class="center"></span></span>
    <div class="box-delete" ref="box-delete">
      <div class="box-container">
        <span class="x">X</span>
        <b-form-input
          type="number"
          class="input-box"
          v-model="repeat"
          @blur="handleBlur"
        ></b-form-input>
        <b-button variant="link" @click="unround()">
          <b-icon
            icon="trash-fill"
            aria-hidden="true"
            variant="danger"
          ></b-icon>
        </b-button>
      </div>
    </div>
  </div>
</template>